import ScopeType from 'utils/enums/ScopeType';

/**
 * Scope to send as `X-RequestScope` when saving a number.
 *
 * A company whose `perNumberPlan` is 2 ("Partner Only") rejects per-number plan
 * writes made below partner scope. A partner admin managing one of their
 * companies sits at view scope 20, so the save has to go out at the admin's own
 * account scope (`login.requiredScope`) rather than the org level they happen to
 * be looking at — otherwise the API answers "Per Number plans are only
 * configurable by a Partner on this Company".
 *
 * @param {object} params
 * @param {number} [params.perNumberPlan] 0 = Disabled, 1 = Enabled, 2 = Partner Only
 * @param {number} [params.accountScope] the user's own level (`login.requiredScope`)
 * @param {number} [params.viewScope] the org level being managed (`login.currentScope`)
 * @returns {number} scope to send with the update
 */
export const getNumberSaveScope = ({
    perNumberPlan,
    accountScope,
    viewScope,
}) =>
    perNumberPlan === 2 && accountScope >= ScopeType.PARTNER
        ? accountScope
        : viewScope;

export default getNumberSaveScope;
